import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  // 狀態：判斷是否為手機版
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 定義一個偵測視窗寬度的函式
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // 初始判斷
    handleResize();

    // 監聽視窗大小變化
    window.addEventListener('resize', handleResize);

    // 清理監聽
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 依據裝置顯示不同的 loading 圖片（改用 webp）
  const loadingImg = isMobile ? '/banner1-m.webp' : '/banner1.webp';

  // 點擊圖片導向 /stock
  const handleBannerClick = () => {
    navigate('/stock');
  };

  return (
    <div className="home-page">
      <main className="home-main">
        <div className="home-banner">
          <img
            src={loadingImg}
            alt="ちいかわ開心代購"
            className="home-banner-img"
            style={{ cursor: 'pointer' }}
            onClick={handleBannerClick}
          />
        </div>
      </main>
    </div>
  );
}

export default HomePage; 